module.exports = __webpack_public_path__ + "static/media/nav-icon3.87f76906.svg";